exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".upload-container___37L2x {\n  position: relative;\n  top: 1rem;\n}\n\n.upload-input___3yph7 {\n  z-index: 200;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 47px;\n  display: inline-block;\n  opacity: 0;\n}\n\n.upload-button___24Iac {\n  position: relative;\n  z-index: 100;\n}\n", ""]);

// exports
exports.locals = {
	"upload-container": "upload-container___37L2x",
	"upload-input": "upload-input___3yph7",
	"upload-button": "upload-button___24Iac"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/test.css
// module id = 773
// module chunks = 2